import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Fusionne des classes Tailwind en résolvant les conflits (dernière gagne). */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/** URL absolue en `http(s)` — garde-fou avant d'injecter une URL venue du Pass dans du HTML. */
export const isHttpUrl = (value: unknown): value is string => {
    if (typeof value !== 'string') return false;
    try {
        return ['http:', 'https:'].includes(new URL(value).protocol);
    } catch {
        return false;
    }
};
